<template>
  <div>
    <ErrorMessageBar
      v-if="local.error "
      :message="local.error"
    />
    <ScheduleReport
      v-model="local"
      :show="showScheduleReportSlideOut"
      :isEditing="true"
      @toggleSlideOut="toggleSlideOut"
      @changeScheduleReportId="changeScheduleReportId"
      @cancel="toggleSlideOut(false)"
      @deleteReportSchedule="deleteReportSchedule"
      @saveAndScheduleReport="updateScheduledReport"
      @sendPreview="sendPreview"
    />
    <SavedReportsHeader
      :searchTerm="searchTerm"
      @toggleSlideOut="toggleSlideOut"
      @updateSearchTerm="updateSearchTerm"
      @updateErrorMessage="updateErrorMessage"
      @changeScheduleReportId="changeScheduleReportId"
    />
    <SavedReportsContent
      ref="savedReportsContent"
      :searchTerm="searchTerm"
      :error="local.error"
      :selectedReportId="local.scheduleReportId"
      @toggleSlideOut="toggleSlideOut"
      @changeScheduleReportId="changeScheduleReportId"
      @updateSearchTerm="updateSearchTerm"
      @updateErrorMessage="updateErrorMessage"
    />
  </div>
</template>

<script>
import ScheduleReport from '../Common/ScheduleReport/ScheduleReport';
import SavedReportsHeader from '../SavedReports/SavedReportsHeader';
import SavedReportsContent from '../SavedReports/SavedReportsContent';
import ErrorMessageBar from '../SavedReports/ErrorMessageBar';
import snackbarMixin from '../../../mixins/snackbar';
import {
  setScheduledReport,
  sendPreviewReport,
  isReportScheduled,
} from '../../../services/dashboard/scheduledReportService';
import eventDispatcher from '../../../events/dispatch';

export default {
  mixins: [ snackbarMixin ],
  beforeMount() {
    this.$store.commit('updateActiveView', 'Saved Reports');
  },
  components: {
    ScheduleReport,
    SavedReportsHeader,
    SavedReportsContent,
    ErrorMessageBar,
  },
  data() {
    return {
      showDeleteModal: false,
      showScheduleReportSlideOut: false,
      searchTerm: '',
      viewName: 'Saved Reports',
      local: {
        scheduleReportId: '',
        error: '',
      },
    };
  },
  methods: {
    toggleSlideOut(shouldShow) {
      this.showScheduleReportSlideOut = shouldShow;
    },
    changeScheduleReportId(newId) {
      this.local.scheduleReportId = newId;
    },
    updateSearchTerm(newVal) {
      this.searchTerm = newVal;
    },
    updateErrorMessage(newMessage) {
      this.local.error = newMessage;
    },
    getScheduledReportData(schedulingData) {
      const {
        reportName,
        emailFrequency,
        emailSubject,
        fileType,
        emailRecipients,
        reportId,
        startDate,
        endDate,
        filterJson,
        aggregateDays,
      } = schedulingData;

      return {
        reportId: reportId,
        name: reportName,
        schedule: emailFrequency && emailFrequency !== 'not scheduled' ? emailFrequency : null,
        emailSubject: emailSubject || '',
        startDate: startDate && new Date(startDate).toISOString(),
        endDate: endDate && new Date(endDate).toISOString(),
        fileType: fileType || 'csv',
        recipientEmails: emailRecipients || [],
        filterJson,
        aggregateDays,
      };
    },
    async sendPreview(schedulingData) {
      const reportData = {
        timestamp: Date.now(),
        report: this.getScheduledReportData(schedulingData),
      };

      try {
        const token = await this.$auth.getTokenSilently();

        this.alertSnackbar(`Preview sent to ${reportData.report.recipientEmails[0]}`);

        await sendPreviewReport(reportData, token);
      } catch (e) {
        const errorMessage = this.getErrorMessage(e);

        throw errorMessage;
      }
    },
    async deleteReportSchedule(schedulingData) {
      await this.updateScheduledReport(schedulingData, 'delete');
    },
    async updateScheduledReport(schedulingData, actionTaken) {
      const reportData = this.getScheduledReportData(schedulingData);

      let hasError = false;
      let errorMessage = '';

      try {
        const token = await this.$auth.getTokenSilently();

        await setScheduledReport(reportData.reportId, reportData, token);

        this.showSaveReportPopUp = false;
        const snackBarMessage = this.getReportScheduledSnackbarMessage(
          reportData.name,
          actionTaken,
        );

        this.alertSnackbar(snackBarMessage);

        this.$refs.savedReportsContent.updateScheduleData(reportData);

        return reportData.reportId;
      } catch (e) {
        hasError = true;
        errorMessage = this.getErrorMessage(e);

        throw errorMessage;
      } finally {
        const eventType = isReportScheduled(reportData)
          ? 'dashboardReportScheduled'
          : 'dashboardReportSaved';

        eventDispatcher(eventType, {
          dashboard_view: this.viewName,
          scheduled_report_id: reportData.reportId,
          updated_at: new Date(),
          has_error: hasError,
          error_message: errorMessage,
        });
      }
    },
    getReportScheduledSnackbarMessage(reportName, actionTaken) {
      return actionTaken === 'delete'
        ? `Schedule for ${reportName} deleted.`
        : `Report for ${reportName} scheduled.`;
    },
    getErrorMessage(error) {
      return (error && error.message) || error;
    },
  },
};
</script>
